import Axios from 'axios'

const tableStatuses = {
  namespaced: true,
  state: {
    tableStatuses: {},
    croupierNames: {},
    loading: false,
    error: null
  },
  actions: {
    async updateTableStatuses({ commit }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)

      try {
        const response = await Axios({
          url: '/api/v1/tables/statuses',
          method: 'GET'
        })

        const tables = response.data.tables || []
        const statusesMap = {}

        tables.forEach(table => {
          statusesMap[table.tableId] = table.status
        })

        commit('SET_TABLE_STATUSES', statusesMap)
      } catch (err) {
        console.error('Error updating table statuses:', err)
        commit('SET_ERROR', err)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateCroupierNames({ commit }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)

      try {
        const response = await Axios({
          url: '/api/v1/tables/croupier-names',
          method: 'GET'
        })

        const tables = response.data.tables || []
        const namesMap = {}

        tables.forEach(table => {
          namesMap[table.tableId] = table.name || '—'
        })

        commit('SET_CROUPIER_NAMES', namesMap)
      } catch (err) {
        console.error('Error updating croupier names:', err)
        commit('SET_ERROR', err)
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  mutations: {
    SET_TABLE_STATUSES(state, payload) {
      state.tableStatuses = payload
    },
    SET_CROUPIER_NAMES(state, payload) {
      state.croupierNames = payload
    },
    SET_LOADING(state, payload) {
      state.loading = payload
    },
    SET_ERROR(state, payload) {
      state.error = payload
    }
  },
  getters: {
    tableStatuses: state => state.tableStatuses,
    croupierNames: state => state.croupierNames,
    isTableClosed: state => tableId =>
      state.tableStatuses[tableId] === 'closed',
    getCroupierName: state => tableId => state.croupierNames[tableId] || '—',
    loading: state => state.loading,
    error: state => state.error
  }
}

export default tableStatuses
